import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ab-request-method-switch",
  templateUrl: "./request-method-switch.component.html",
})
export class RequestMethodSwitchComponent {
  @Input() public featureDisabled: boolean;
  @Input() public requestMethod: string;
  @Output() public changed = new EventEmitter<string>();
  @Output() public deleted = new EventEmitter<void>();

  public requestMethods = [
    "GET",
    "POST",
    "PUT",
    "PATCH",
    "HEAD",
    "DELETE",
    "OPTIONS",
  ];

  public trackByIndex(index: number, _item: any) {
    return index;
  }

  public selectRequestMethod(requestMethod: string) {
    this.changed.emit(requestMethod);
    this.requestMethod = requestMethod;
  }

  public deleteRequestMethod() {
    this.deleted.emit();
    delete this.requestMethod;
  }
}
